import { useState, type FormEvent } from 'react'
import { getStoredUser, mergeStoredUser, updateMyProfile } from '../../lib/api'

export function GeneralSection() {
  const storedUser = getStoredUser()
  const [name, setName] = useState(storedUser?.name ?? '')
  const [avatarUrl, setAvatarUrl] = useState(storedUser?.avatarUrl ?? '')
  const [bio, setBio] = useState(storedUser?.bio ?? '')
  const [phone, setPhone] = useState(storedUser?.phone ?? '')
  const [country, setCountry] = useState(storedUser?.country ?? '')
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (isSaving) return
    setError(null)
    setSuccess(false)
    setIsSaving(true)
    try {
      const updated = await updateMyProfile({
        name: name.trim() || undefined,
        avatarUrl: avatarUrl.trim() || undefined,
        bio: bio.trim() || undefined,
        phone: phone.trim() || undefined,
        country: country.trim() || undefined,
      })
      mergeStoredUser(updated)
      setSuccess(true)
    } catch {
      setError('No se pudo actualizar el perfil. Verifica los datos e intenta de nuevo.')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <section>
      <p className="account-section__eyebrow">SateLab</p>
      <h1 className="account-section__title">Tu cuenta</h1>
      <p className="account-section__subtitle">
        Una sola cuenta para todo el ecosistema SateLab. Se refleja en Academy, CCCD y el resto de plataformas.
      </p>

      <div className="account-section__body">
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label" htmlFor="profile-email">
            Correo (inicio de sesión)
          </label>
          <input id="profile-email" className="auth-input" value={storedUser?.email ?? ''} disabled />

          <label className="auth-label" htmlFor="profile-name">
            Nombre
          </label>
          <input
            id="profile-name"
            className="auth-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <label className="auth-label" htmlFor="profile-avatar">
            Foto (URL)
          </label>
          <input
            id="profile-avatar"
            className="auth-input"
            placeholder="https://…"
            value={avatarUrl}
            onChange={(e) => setAvatarUrl(e.target.value)}
          />

          <label className="auth-label" htmlFor="profile-bio">
            Biografía
          </label>
          <input id="profile-bio" className="auth-input" value={bio} onChange={(e) => setBio(e.target.value)} />

          <label className="auth-label" htmlFor="profile-phone">
            Teléfono
          </label>
          <input id="profile-phone" className="auth-input" value={phone} onChange={(e) => setPhone(e.target.value)} />

          <label className="auth-label" htmlFor="profile-country">
            País
          </label>
          <input
            id="profile-country"
            className="auth-input"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          />

          {error && (
            <p className="auth-error" role="alert">
              {error}
            </p>
          )}
          {success && (
            <p className="account-success" role="status">
              Perfil actualizado correctamente.
            </p>
          )}

          <button type="submit" className="auth-button" disabled={isSaving}>
            {isSaving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </form>
      </div>
    </section>
  )
}
